export default __webpack_public_path__ + "static/compareItemImg3-bad13eb20f14fb3eb7dbcdef577c507b.webp";